import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';

export default class BaseTopMenuFeature {
    public id = '';

    public callback(obj?: any, option?: any) {
        this.getMenuManager()?.topMenu()
            ?.callback(MenuType.TOP_MENU, this.id, obj, option);
    }

    /**
     * 获取当前按键的值
     */
    public getItemValue() {
        const values = this.getMenuManager()?.topMenu().values;
        return values?.[this.id] || '';
    }

    public getAppService(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    public getMenuManager(): IMenuManager | undefined {
        return this.getAppService().editableServiceLayer?.menuManager;
    }
}
